module.exports = __webpack_public_path__ + "img/rolling down the slope.2c0fcdc0.png";